import { createAsyncThunk } from '@reduxjs/toolkit'
import { myAddressesApi } from 'feature/addresses/redux/MyAddresses.api'
import { appealApi } from 'feature/appeals/redux/appeals.api'
import { logout } from 'feature/auth/api'
import { orderFormActions } from 'feature/productOrder/redux/orderFormSlice'
import { servicesApi } from 'feature/serviceCenters/redux/service.api'
import { userApi } from 'feature/user/redux/user.api'
import { RootState } from 'store/types'

import { AuthStatus, authActions } from '../authSlice'
import { deleteRegistrationLkmFields } from 'feature/registration/storage/registrationLkmStorage'

// разлогиниваем пользователя
// делаем неактивными токены
export const doLogout = createAsyncThunk<
  void,
  boolean | void,
  { state: RootState }
>('auth/doLogout', (resetValue, { getState, dispatch }) => {
  const logoutActions = () => {
    if (resetValue === undefined || resetValue === true)
      dispatch(orderFormActions.resetOrderForms())
    dispatch(
      authActions.setAuthInfo({
        status: AuthStatus.guest,
        accessToken: null,
        refreshToken: null,
      }),
    )
    dispatch(authActions.setClientTypeInfo(null))
    dispatch(
      authActions.setUserInfo({
        phone: '',
        isDataAgreeRequired: false,
      }),
    )
    dispatch(userApi.util.resetApiState())
    dispatch(servicesApi.util.resetApiState())
    dispatch(myAddressesApi.util.resetApiState())
    dispatch(appealApi.util.resetApiState())
    localStorage.clear()
    deleteRegistrationLkmFields()
  }

  const authInfo = getState().auth.authInfo
  if (authInfo.status !== AuthStatus.registered) {
    logoutActions()
    return
  }
  dispatch(authActions.setAuthInfo({ isLoading: true }))
  logout()
    // .catch(() => {})
    // .catch((error: { response: { data: { message: string | null } } }) => {
    //   // dispatch(authActions.setSmsError(error.response.data.message))s
    // })
    .finally(() => {
      logoutActions()
      dispatch(authActions.setAuthInfo({ isLoading: false }))
    })
})
